import { 
    getContractTypeList, 
    postContract,
    getContractList,
    deleteContract ,
    getContractById,
    updateContract,
    getSellingContract
} from "@/services/contract.service";
import { setPaginationDetails } from "../../utils/utils";

const state = () => ({
    contractModel: {},
  });

  const mutations = {
    setContractModel(state, data) {
      state.contractModel = data;
    },
  };

const actions = {

    async loadSellingContract(vuexContext, request) {
        return await getSellingContract(request).then((response) => {
          let data = response.data.data;
          return data;
        });
      },

    async loadContractTypeList(vuexContext, co) {
        return await getContractTypeList(co).then((response) => {
          let data = response.data.data;
          let items = data.items;
          let totalCount = data.totalCount;
          let totalPages = data.totalPages;
    
          setPaginationDetails(co, totalCount, totalPages);
    
          return items;
        });
      },

      async postContract(vuexContext, data) {
        return await postContract(data).then((response) => {
          let data = response;
          return data;
        });
      },

      async loadContractList(vuexContext, co) {
        return await getContractList(co).then((response) => {

          let data = response.data.data;
          let items = data.items;
          let totalCount = data.totalCount;
          let totalPages = data.totalPages;

          items.map((item, index) => {
            item.index = index + 1;
          })
    
          setPaginationDetails(co, totalCount, totalPages);
    
          return items;
        });
      },

      addContractModel(vuexContext, data) {
        vuexContext.commit("setContractModel", data);
      },

      async deleteContract(vuexContext, data) {
        return await deleteContract(data).then((response) => {
          let data = response;
          return data;
        });
      },

      async loadContractById(vuexContext, contractId) {
        return await getContractById(contractId).then((response) => {
          let data = response.data;
          return data;
        });
      },

      async updateContract(vuexContext, data) {
        return await updateContract(data).then((response) => {
          let data = response;
          return data;
        });
      },
}

export default {
    namespaced: true,
    state,
    actions,
    mutations,
  };

